import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-return-assign */
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { createElement } from '@jd/jmtd-tools/es/element';
import Icon from '../Icon';
import PortalContext from '../PortalContext';
import PortalZIndex from '../PortalZIndex';

var Modal = /*#__PURE__*/function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  var _super = _createSuper(Modal);

  function Modal() {
    _classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          style = _this$props.style,
          visible = _this$props.visible,
          open = _this$props.open,
          width = _this$props.width,
          top = _this$props.top,
          zIndex = _this$props.zIndex,
          portalZIndex = _this$props.portalZIndex,
          onClose = _this$props.onClose,
          maskClosable = _this$props.maskClosable,
          showCloseBtn = _this$props.showCloseBtn,
          children = _this$props.children;

      var contentStyle = _objectSpread(_objectSpread({}, style), {}, {
        marginTop: top,
        width: width
      });

      var absoluteCenter = !top && top !== 0;
      return /*#__PURE__*/React.createElement(PortalZIndex, null, function (_ref) {
        var _this$portalElement;

        var portalStyle = _ref.style,
            enable = _ref.enable;
        return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
          id: id,
          className: classNames('jmtd-modal', className, {
            'jmtd-modal-hidden': !visible && !open
          })
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-modal-mask",
          style: {
            zIndex: zIndex
          },
          onClick: function onClick() {
            if (maskClosable) {
              onClose();
            }
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: classNames('jmtd-modal-wrap', {
            'jmtd-modal-absolute-center': absoluteCenter
          }),
          style: {
            zIndex: zIndex
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-modal-content",
          style: contentStyle,
          "data-event-container": true
        }, // 右上方关闭按钮
        showCloseBtn && /*#__PURE__*/React.createElement("span", {
          className: "jmtd-modal-delete-icon",
          onClick: onClose
        }, /*#__PURE__*/React.createElement(Icon, {
          size: "large",
          className: "jmti-close"
        })), /*#__PURE__*/React.createElement(PortalContext, null, children)))), (_this$portalElement = _this.portalElement) !== null && _this$portalElement !== void 0 ? _this$portalElement : _this.portalElement = createElement('div.jmtd-modal-portal', {
          classList: enable || portalZIndex ? ['jmtd-portal-adjust'] : [],
          style: _objectSpread(_objectSpread({}, portalStyle), portalZIndex ? {
            'z-index': portalZIndex
          } : null)
        }, document.body));
      });
    }
  }]);

  return Modal;
}(PureComponent);

Modal.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  // 自定义class
  style: PropTypes.object,
  // 自定义弹框的样式
  visible: PropTypes.bool,
  // 控制弹框是否显示，已废弃
  open: PropTypes.bool,
  // 控制弹框是否显示
  width: PropTypes.number,
  // 弹框宽度
  top: PropTypes.number,
  // 弹框距离顶部高度
  zIndex: PropTypes.number,
  // 弹框定位权重
  onClose: PropTypes.func,
  // 点击遮罩回调
  maskClosable: PropTypes.bool,
  // 点击遮罩关闭弹框
  showCloseBtn: PropTypes.bool,
  // 显示右上方关闭按钮
  children: PropTypes.node,
  portalZIndex: PropTypes.number
};
Modal.defaultProps = {
  id: null,
  className: '',
  style: {},
  visible: false,
  open: false,
  width: undefined,
  top: undefined,
  zIndex: undefined,
  onClose: function onClose() {},
  maskClosable: false,
  showCloseBtn: false,
  children: '',
  portalZIndex: undefined
};
export default Modal;